import React, { useMemo } from 'react';

import { useLocalSearchParams } from 'expo-router';
import { MenuHeaderNavigation } from 'features/menu/components/menu-header-navigation';
import { MenuNavigationTabs } from 'features/menu/components/menu-navigation-tabs/menu-navigation-tabs';
import { MenuSection } from 'features/menu/components/menu-section/menu-section';
import { View } from 'react-native';

import { AppTakeoverMenuSectionTransition } from 'components/app-takeover/app-takeover-menu-section-transition';
import { useAppTakeoverMenuSection } from 'components/app-takeover/use-app-takeover';
import { FullWidthAutoHeightImage } from 'components/picture';
import { useUnifiedMenuContext } from 'state/unified-menu/unified-menu-context';
import { isWeb } from 'utils/environment';

// NEW one menu
export const MenuSectionPage = () => {
  const { mainMenu } = useUnifiedMenuContext();
  const { id } = useLocalSearchParams<{ id: string }>();

  const { title, options } = useMemo(() => {
    const section = mainMenu?.find(section => section.id === id);
    return { title: section?.name || '', options: section?.children || [] };
  }, [id, mainMenu]);

  const {
    headerBackgroundColor,
    headerBackgroundImage,
    itemBackgroundColor: takeoverBg,
    footerImage: takeoverFooterImage,
    footerImageOffset: takeoverFooterImageOffset,
  } = useAppTakeoverMenuSection(id);

  const headerBackgroundColorOverride =
    headerBackgroundColor || headerBackgroundImage ? 'transparent' : undefined;

  const tabs = (
    <>
      {/* key is used to force re-render and display Section name after reloading page, 
          there is a memo messing up prop comparison */}
      <MenuHeaderNavigation
        title={title}
        key={title}
        headerBackgroundColorOverride={headerBackgroundColorOverride}
      />
      <MenuNavigationTabs
        mainMenu={mainMenu}
        headerBackgroundColorOverride={headerBackgroundColorOverride}
      />
    </>
  );

  return (
    <View style={{ flex: 1, backgroundColor: takeoverBg }}>
      <AppTakeoverMenuSectionTransition sectionId={id} />
      {headerBackgroundImage ? (
        <View>
          <FullWidthAutoHeightImage source={headerBackgroundImage} />
          <View style={{ position: 'absolute', bottom: 0, left: 0, right: 0 }}>{tabs}</View>
        </View>
      ) : (
        tabs
      )}
      <MenuSection data={options} />
      {/* takeoverFooterImage uses position:absolute bottom:0 to overlay the viewport bottom on native.
                On web, View flex:1 has a fixed viewport height so the image — whether absolute or inline —
                reduces available space and blocks list content. */}
      {takeoverFooterImage && !isWeb && (
        <>
          {takeoverFooterImageOffset && (
            <View style={{ width: '100%', height: takeoverFooterImageOffset }}></View>
          )}
          <FullWidthAutoHeightImage
            source={takeoverFooterImage}
            style={{ position: 'absolute', bottom: 0 }}
          />
        </>
      )}
    </View>
  );
};
